import Icon from '../../components/Icon'

Icon.register({
  'brands/mixer': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M114.6 76.1l128.3 172.4c1.4 2 2.3 4.5 2.3 7.1 0 2.7-0.9 5.1-2.3 7.1l-128.9 173.2c-8.3 11.2-21.7 18.4-36.7 18.4-11.9 0-22.7-4.5-30.8-12-17.8-16.2-19-43.5-4.7-62.8l92.3-124.2-91.8-123c-14.3-19.3-12.8-46.6 4.8-62.8 8.1-7.4 19-12 30.8-12 15 0 28.3 7.3 36.7 18.4zM470.2 379.6c14.2 19.3 13.1 46.6-4.7 62.8-8.1 7.4-19 12-30.8 12-15 0-28.3-7.3-36.7-18.4l-128.6-173.5c-1.4-2-2.3-4.5-2.3-7.1 0-2.7 0.9-5.1 2.3-7.1l128-172.1c8.3-11.2 21.7-18.4 36.7-18.4 11.9 0 22.7 4.5 30.8 12 17.6 16.2 19 43.5 4.8 62.8l-91.8 123z'
      }
    ]
  }
})
